<template>
  <teams-wrapper
    class="teams-wrapper"
    :sendTestMessageButtonDisabled="sendTestMessageButtonDisabled"
    @sendTestMessage="$emit('sendTestMessage')"
  >
    <div class="mb-2 d-flex justify-content-center">
      <iframe :srcdoc="messageContent" height="350px" width="500px" frameBorder="0"></iframe>
    </div>
  </teams-wrapper>
</template>

<script>
import TeamsWrapper from './wrapper';
import { mapRoot } from '@src/mixins/root';

export default {
  name: 'CampaignAdminCampaigns',
  components: {
    TeamsWrapper,
  },
  props: {
    fromEmail: {
      type: String,
    },
    job: {
      type: Object,
    },
    contentShare: {
      type: Object,
    },
    jobs: {
      type: Array,
    },
    contentShares: {
      type: Array,
    },
    collectiveGoal: {
      type: Object,
    },
    body: {
      type: String,
    },
  },
  computed: {
    ...mapRoot([ 'user' ]),
    messageContent() {
      const { body, replaceVariables } = this;
      if (body) {
        return replaceVariables(body);
      }
      return null;
    },
    sendTestMessageButtonDisabled() {
      const { fromEmail } = this;
      return !fromEmail || !fromEmail.includes('@');
    },
    variables() {
      const { job, contentShare, collectiveGoal, jobs, contentShares } = this;
      const randomCollectiveGoalProgress = Math.round(Math.random() * 100);
      const globalJobVariables = (jobs || []).reduce((r, c) => {
        console.log({ c });
        const location = c && c.customFields && c.customFields.find(({ key, value }) => key === 'location' && value) ? c.customFields.find(({ key, value }) => key === 'location' && value).value : null;
        return {
          ...r,
          [`JOB_${c.id}_TITLE`]: location ? `${(c || {}).title} - ${location}` : (c || {}).title,
          [`JOB_${c.id}_DESCRIPTION`]: (c || {}).excerpt,
          [`JOB_${c.id}_SHARE_TEXT`]: `Work with me as a ${(job || {}).title}`,
        };
      }, {});
      const globalContentShareVariables = (contentShares || []).reduce((r, c) => ({
        ...r,
        [`CONTENT_${c.id}_TITLE`]: (c || {}).title,
        [`CONTENT_${c.id}_DESCRIPTION`]: (c || {}).description,
        [`CONTENT_${c.id}_SHARE_TEXT`]: 'We are hiring. Apply to one of our openings!',
      }), {});
      return {
        FIRST_NAME: 'John',
        LAST_NAME: 'Doe',
        FULL_NAME: 'John Doe',
        LEADERBOARD_POSITION: Math.round(Math.random() * 100),
        LEADERBOARD_POINTS: Math.round(Math.random() * 500),
        JOB_TITLE: (job || {}).title || ' - ',
        JOB_DESCRIPTION: (job || {}).excerpt || ' - ',
        JOB_SHARE_TEXT: `Work with me as a ${(job || {}).title || ' - '}`,
        JOB_SHARE_LINK: 'https://example.reallinks.io/sharelink',
        JOB_MATCH_LINK: (job || {}).linkedInSearchURL || ' - ',
        CONTENT_TITLE: (contentShare || {}).title || ' - ',
        CONTENT_DESCRIPTION: (contentShare || {}).description || ' - ',
        CONTENT_SHARE_TEXT: 'We are hiring. Apply to one of our openings!',
        CONTENT_SHARE_LINK: 'https://example.reallinks.io/sharelink',
        LEADERBOARD_FIRST_POINTS: 1356,
        LEADERBOARD_SECOND_POINTS: 1110,
        LEADERBOARD_THIRD_POINTS: 936,
        LEADERBOARD_FIRST_NAME: 'John Doe',
        LEADERBOARD_SECOND_NAME: 'Mary Doe',
        LEADERBOARD_THIRD_NAME: 'Steve Doe',
        LEADERBOARD_FIRST_PRIZE_TITLE: '£1000 Amazon Voucher',
        LEADERBOARD_SECOND_PRIZE_TITLE: '£500 Amazon Voucher',
        LEADERBOARD_THIRD_PRIZE_TITLE: '£200 Amazon Voucher',
        PLATFORM_LINK: origin.includes('localhost') ? 'https://referrals.reallinks.dev' : origin,
        COLLECTIVE_GOAL_HEADLINE: (collectiveGoal || {}).headline || ' - ',
        COLLECTIVE_GOAL_PROGRESS: randomCollectiveGoalProgress,
        COLLECTIVE_GOAL_ICON: (collectiveGoal || {}).icon || '',
        COLLECTIVE_GOAL_FIRST_LINE: ((collectiveGoal || {}).display || {}).firstLine || ' - ',
        COLLECTIVE_GOAL_SECOND_LINE: ((collectiveGoal || {}).display || {}).secondLine || ' - ',
        COLLECTIVE_GOAL_PERCENTAGE: randomCollectiveGoalProgress,
        COLLECTIVE_GOAL_PERCENTAGE_REMINDER: 100 - randomCollectiveGoalProgress,
        ...globalJobVariables,
        ...globalContentShareVariables
      };
    }
  },
  methods: {
    replaceVariables(text) {
      const { variables } = this;
      console.log({ variables, contentShares: this.contentShares });
      let newText = text;
      Object.keys(variables).forEach(key => {
        newText = newText.replace(new RegExp(`{{${key}}}`, 'g'), variables[key]);
      });
      return newText;
    },
  },
};
</script>

<style lang="scss">
.teams-wrapper {
  .text-wrapper {
    p {
      margin-bottom: 5px;
    }
    a > pre {
      color: #fff !important;
      padding: 5px 8px;
    }
    h1 {
      font-size: 18px;
      margin-bottom: 10px;
    }
    h2 {
      font-size: 16px;
      margin-bottom: 10px;
    }
    h3 {
      font-size: 14px;
      margin-bottom: 8px;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/campaign-admin/message-previews/emails/content.vue